(function () {
    "use strict";

    // @ngInject
    function NetworkProfileControllerCtor($scope, $injector, $stateParams, UsersManager, NetworkManager, AppStates,
                                          AnalyticsService, CompanyService,PopupMessageService,ModalService,NetworkOnboardingService, UIUtils, $filter,
                                          $state, _, ConversationService, $timeout, ModelFactory, ContactsManager, InitialAppLoadParamsService,
                                          $translate) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkProfileController';
        this.$scope = $scope;
        this.UsersManager = UsersManager;
        this.userId = $stateParams.user_id;
        this.actionFromState = $stateParams.action;
        this.CompanyService = CompanyService;
        this.ModalService = ModalService;
        this.AnalyticsService =AnalyticsService;
        this.PopupMessageService = PopupMessageService;
        this.NetworkOnboardingService = NetworkOnboardingService;
        this.UIUtils = UIUtils;
        this._ = _;
        this.AppStates = AppStates;
        this.NetworkManager = NetworkManager;
        this.ContactsManager = ContactsManager;
        this.ModelFactory = ModelFactory;
        this.ConversationService = ConversationService;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.vendorTypes = this.CompanyService.getCompanyTypesEnum();
        this.vendorTypeTranslationMap = this.CompanyService.getCompanyTypesTranslationMap();
        var trackingData = {};
        // Reload network user if viewing own profile
        if(this.userId){
            this.currUser = this.NetworkManager.getNetworkCurrUser(false);
        } else {
            this.currUser = this.NetworkManager.getNetworkCurrUser(true);
        }

        this.isActiveConnectionsTab = false;

        this.currUserId = this.currUser ? this.currUser._id : undefined;
        this.connectionStatus = "unconnected";
        this.loadingProjects = true;
        this.$state = $state;
        this.viewsNumber = null;
        this.connectionsPage = 1;
        this.canLoadMore = false;
        this.connections = this.ModelFactory.newNetworkUsersCollection();
        this.register(this.connections, 'success', function(successType, respStatus, respIsComplete) {
            this.loadingConnections = false;
            this.canLoadMore = !respIsComplete;
            // this.connections = $filter('filter')(this.connections, {network: {connection_data: {connection_status: 'connected'}}});

        }.bind(this));

        // placeholder
        this.hasBadgePro = false;
        this.badgeProSubtext = 'Since Aug 2016';

        var faces = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29];

        faces = this._.shuffle(faces);
        this.face1style = {'background-position-y': (faces.pop() * -20) + "px"};

        faces = this._.shuffle(faces);
        this.face2style = {'background-position-y': (faces.pop() * -20) + "px"};

        faces = this._.shuffle(faces);
        this.face3style = {'background-position-y': (faces.pop() * -20) + "px"};

        // If user id has been provided, fetch the user or redirect to my profile
        if(this.userId){
            trackingData.userId = this.userId;
            this.user = this.NetworkManager.getNetworkUser(this.userId);
            this.NetworkManager.setUserProfileViewed(this.user);

            this.register(this.user, 'success', function(successType, respStatus, respIsComplete) {
                if(this.user.network.removed){
                    this.goToState(this.AppStates.root_core_navigation_creatives);
                    return;
                }

                if(this.user._id && this.currUser._id !== this.user._id){
                    // make sure network user was received
                    if (this.user.network._id){
                        this.fetchProjects();

                        var isConnectionRequest = false;
                        if (this.user.network.connection_data && this.user.network.connection_data.connection_status){
                            this.connectionStatus = this.user.network.connection_data.connection_status;

                            if ((this.actionFromState === 'approve' || this.actionFromState === 'request') &&
                                this.connectionStatus === 'needs_response') {
                                isConnectionRequest = true;
                                this.acceptConnectionRequest('connection email');
                            }
                        }else if(!this.user.network.connection_data && this.actionFromState === 'request'){
                            isConnectionRequest = true;
                            this.createConnectionRequest();
                            AnalyticsService.track(this, AnalyticsService.analytics_events.network_user_connection_request, {
                                user_id: this.user._id,
                                source: 'url'
                            });
                        }
                        if (isConnectionRequest && $stateParams.suggestion_source) {
                            this.NetworkManager.connectionSuggestionConvert(this.user._id, $stateParams.suggestion_source,
                                $stateParams.suggestion_source_details);
                        }

                        var initialFirst = (this.user.network.first_name && this.user.network.first_name.length) ? this.user.network.first_name[0] : '';
                        var initialLast = (this.user.network.last_name && this.user.network.last_name.length) ? this.user.network.last_name[0] : '';

                        this.initials = initialFirst + initialLast;
                        
                        // emit name for header nav title, via network controller broadcast
                        this.$scope.$emit('emitPageTitle', this.user.network.full_name);
                    }

                } else {
                    this.goToState(this.AppStates.root_network_my_profile);
                }

            }.bind(this));

        } else {

            this.user = this.currUser;
            this.userId = this.user._id;

            this.fetchProjects();
            this.register(this.currUser, 'network_user_success', function(){
                this.viewsNumber = this.getProfileViewNumber(this.currUser);
            });
        }
        this.NetworkManager.getConnections(this.connections, this.userId,this.connectionsPage);

        this.conversationId = $stateParams.cid;
        if(this.conversationId){
            this.ConversationService.openConversation(this.conversationId);
        }

        AnalyticsService.trackPageView(this, 'network user profile', trackingData);
        
        this.isShowingNotes = false;



        if ($stateParams.tab === 'connections') {
            this.isActiveConnectionsTab = true;
        }



    }

    Controllers.NetworkProfileController = Class(Controllers.BaseController, {

        constructor: NetworkProfileControllerCtor,

        updateConnection: function updateConnection(event, action) {
                event.stopPropagation();
                event.preventDefault();
                this.NetworkManager.updateConnection(this.user, action);
        },

        loadMore: function loadMore(){
            this.connectionsPage++;
            this.loadingConnections = true;
            this.NetworkManager.getConnections(this.connections, this.userId,this.connectionsPage);
        },

        createConnectionRequest: function createConnectionRequest(){

            var newConnection = this.NetworkManager.createConnectionRequest(this.user._id)

            this.connectionStatus = 'requested';
            this.register(newConnection, 'success', function gotNewConnection(successType, respStatus, respIsComplete) {
                this.user.network.contact = newConnection.network.contact;
            });
        },


        createProject: function createProject() {

            // var newProject = this.NetworkManager.createNetworkProject();
            // newProject.on('success',function (){
            //     this.goToState(this.AppStates.root_network_edit_project,{project_id: newProject._id});
                this.goToState(this.AppStates.root_network_create_project);
            //
            // }.bind(this));
        },

        fetchProjects: function fetchProjects() {
            // Fetch user projects
            this.user.network.projects = this.NetworkManager.getProjects(this.userId);
            this.user.network.projects.on("success", function(){
                this.loadingProjects = false;
            }.bind(this));
        },

        isCurrUserProfile: function isCurrUserProfile(){
            return this.user._id && this.currUser._id === this.user._id;
        },

        getProfileViewNumber: function getProfileViewNumber(user){
            var profileViews = 7;
            if(user.network.system_generated_views){
                profileViews = Math.max(profileViews, user.network.system_generated_views);
            }
            if(user.network.views){
                profileViews = Math.max(profileViews, user.network.views);
            }
            return profileViews;
         },

         openImproveModal: function openImproveModal(){
             if (this.currUser.network.saw_improve_modal === null) {
                 this.currUser.network.saw_improve_modal = true;
                 var userData = {
                     _id: this.user._id,
                     full_name: this.currUser.network.full_name,
                     about: this.currUser.network.about,
                     city: this.currUser.network.city,
                     state: this.currUser.network.state,
                     company_name: this.currUser.network.company_name,
                     website_url: this.currUser.network.website_url,
                     facebook_url: this.currUser.network.facebook_url,
                     pinterest_url: this.currUser.network.pinterest_url,
                     snapchat_url: this.currUser.network.snapchat_url,
                     instagram_url: this.currUser.network.instagram_url,
                     vendor_type: this.currUser.network.vendor_type,
                     looking_for: this.currUser.network.looking_for,
                     saw_improve_modal: true
                 };
                 this.NetworkManager.updateNetworkUserProfile(this.currUser, userData);
             }

             this.ModalService.openNetworkImproveProfileModal();
         },

        showViews: function showViews(){

             // Currently simply returning false after numerous members have asked about the way views count is being calced.
             // Since this views count is inflated and not precise, I'm currently removing it from UI.
             return false;
           //return this.isCurrUserProfile() && !this.NetworkOnboardingService.isFreshUser(this.currUser) && this.viewsNumber;
        },

        hasBadges: function hasBadges() {
            return this.hasBadgePro || this.user.network.affiliation_rts;
        },

        location: function location() {
            return (this.user.network.company_type && this.user.network.city_state) ? (' • ' + this.user.network.city_state) : '';
        },

        copyProfileLinkToCBSuccess: function copyProfileLinkToCBSuccess() {
            this.showCopiedProfileLink = true;

            this.$timeout(function () {
                this.showCopiedProfileLink = false;
            }.bind(this), 1500);
        },

        acceptConnectionRequest: function approveConnection(source) {
            this.NetworkManager.updateConnection(this.user, 'approve');
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_user_accept, {
                user_id: this.user._id,
                source: source
            });
        },

        openChat: function openChat() {
            var text;
            if(!this.isCurrUserProfile()) {
                if (this.connectionStatus === 'connected') {
                    this.ConversationService.startConversation([this.currUserId, this.userId]);

                } else if (this.connectionStatus === 'requested') {
                    text = this.$translate.instant('NETWORK.PROFILE._CHAT_PENDING_REQUEST_', {firstName: this.user.first_name});
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info,
                        text);

                } else if (this.connectionStatus === 'needs_response') {
                    this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.info,
                        'NETWORK.PROFILE._CHAT_CONFIRM_REQUEST_',
                        function acceptRequest() {
                            this.acceptConnectionRequest('chat disallowed popup');
                        }.bind(this),
                        null,
                        'NETWORK.PROFILE._ACCEPT_');

                } else {
                    text = this.$translate.instant('NETWORK.PROFILE._CHAT_REQUEST_', {firstName: this.user.first_name});
                    this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.info,
                        text,
                        function sendRequest() {
                            this.AnalyticsService.track(this,
                                this.AnalyticsService.analytics_events.network_user_connection_request,
                                {user_id: this.user._id, source: 'chat disallowed popup'});
                            this.createConnectionRequest();
                        }.bind(this),
                        null,
                        'NETWORK.PROFILE._SEND_REQUEST_');
                }
            }

        },

        updateContact: function updateContact(contact) {
            this.NetworkManager.updateContactDetails(contact)
                .then(function success() {
                    this.AnalyticsService.trackSuccess(this, 'update contact details', contact.details);
                }.bind(this));
        },

        openNotes: function openNotes() {
            this.isShowingNotes = true;
        },

        closeNotes: function closeNotes() {
            this.isShowingNotes = false;
        },

        togglePreferred: function togglePreferred() {
            var contact = this.user.network.contact;
            if(!contact) {
                this.ContactsManager.createPreferredContact(this.user, 'community', true)
                    .then(function success(response) {
                        this.user.network.contact = response.data;
                    }.bind(this));
            } else {
                this.ContactsManager.updatePreferredVendorContact(contact, !contact.is_preferred)
                    .then(function success(resp){
                        this.user.network.contact.is_preferred = resp.data.is_preferred;
                    }.bind(this));
            }
        },
        
        showStickyFooterMobile: function showStickyFooterMobile() {
            if (this.isCurrUserProfile()) {
                return Boolean(this.user.network);
            } else {
                return this.connectionStatus === 'unconnected' ||
                       this.connectionStatus === 'ignored' ||
                       this.connectionStatus === 'needs_response';
            }
        },

        simplePluralize: function simplePluralize(str, num) {
            num = num || 0;
            return num === 1 ? '1 ' + str : num + ' ' + str + 's';
        },
    });
}());
